var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 23.8273,
    rx: 24,
    ry: 23.8273,
    fill: "#DDF49A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2844_7017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1088 15.8788V15.867C38.0138 15.6483 37.8417 15.4769 37.6221 15.3824H37.6102C37.5093 15.341 37.4025 15.3174 37.2838 15.3174H29.2715C28.7789 15.3174 28.3813 15.7133 28.3813 16.2038C28.3813 16.6943 28.7789 17.0903 29.2715 17.0903H35.1353L27.2299 24.9618C26.8916 25.2986 26.3099 25.2986 25.9716 24.9618L22.2563 21.2624C21.2118 20.2282 19.5203 20.2223 18.4757 21.2624L9.94707 29.7603C9.59691 30.109 9.59691 30.6704 9.94707 31.0132C10.1192 31.1845 10.3507 31.2732 10.5762 31.2732C10.8017 31.2732 11.0332 31.1845 11.2053 31.0132L19.7399 22.5152C20.0841 22.1666 20.6539 22.1725 20.9981 22.5152L24.7134 26.2146C25.2179 26.7169 25.8886 26.9947 26.6008 26.9947C27.313 26.9947 27.9836 26.7169 28.4881 26.2146L36.3936 18.3431V24.1817C36.3936 24.6722 36.7912 25.0682 37.2838 25.0682C37.7764 25.0682 38.1741 24.6722 38.1741 24.1817V16.2038C38.1741 16.0915 38.1503 15.9793 38.1088 15.8788Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2844_7017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4881,
    height: 15.9558,
    fill: "white",
    transform: "translate(9.68591 15.3174)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnArrow);
export default __webpack_public_path__ + "static/media/earn-arrow.df77d5e009d72c40b6f6b1b3b923a0bb.svg";
export { ForwardRef as ReactComponent };